exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".video-list-item__container__3KYEP{position:relative;overflow:hidden}", "", {"version":3,"sources":["/home/builduser/agent07/work/c8e02a04a4ed599f/src/widget/views/desktop/compact/components/videos/video-list-item/src/widget/views/desktop/compact/components/videos/video-list-item/video-list-item.styl","/home/builduser/agent07/work/c8e02a04a4ed599f/src/widget/views/desktop/compact/components/videos/video-list-item/video-list-item.styl"],"names":[],"mappings":"AAAA,mCACE,kBAAA,eACA,CCCD","file":"video-list-item.styl","sourcesContent":[".container\n  position relative\n  overflow hidden\n",".container {\n  position: relative;\n  overflow: hidden;\n}\n/*# sourceMappingURL=src/widget/views/desktop/compact/components/videos/video-list-item/video-list-item.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "video-list-item__container__3KYEP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/videos/video-list-item/video-list-item.styl
// module id = 2595
// module chunks = 1